/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSendGift.vue?vue&type=template&id=ad54aa6c&scoped=true"
import script from "./popSendGift.vue?vue&type=script&lang=js"
export * from "./popSendGift.vue?vue&type=script&lang=js"
import style0 from "./popSendGift.vue?vue&type=style&index=0&id=ad54aa6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad54aa6c",
  null
  
)

export default component.exports